
import React, { useState } from 'react'
import { Link, useHistory } from "react-router-dom"
import "./auth.css"
import axios from "axios"
import { dispatchLogin } from "../../../redux/actions/authAction"
import { useDispatch } from "react-redux"
import { toast } from 'react-toastify';
import Loader from '../../utils/Loader'
import bg4 from "../../../Images/login.png"

const initialState = { email: "", password: "", plan:""}

export default function Login() {

    const [user, setUser] = useState(initialState)
    const dispatch = useDispatch()
    const history = useHistory()
    const [loading, setLoading] = useState(false)
    const { email, password, plan} = user

    const handleChangeInput = e => {
        const { name, value } = e.target
        setUser({ ...user, [name]: value })
    }


    const handleSubmit = async e => {
        e.preventDefault()

        try {
            setLoading(true)
            const res = await axios.post('https://iq-screener-backend-a7au.vercel.app/api/user/login', { email, password })
            if(res.status == 200){
                setUser({ ...user, err: '', success: res.data.msg })
                let LoginUser = res.data.user
                let login = {isLogged: true, email: LoginUser.email, billingID: LoginUser.billingID, name: LoginUser.name, password: LoginUser.password}
                localStorage.setItem('login', JSON.stringify(login));

                dispatch(dispatchLogin())
                setLoading(false)
                toast.success('Logged In succesfully !', { theme: "colored" });
                history.push('/')
            }else{
                toast.error(`${res.data.msg} !`, {containerId:'DisplayInfo', theme: "colored" });

            }
            
            
        } catch (err) {
            if(err.response != null){
                toast.error(`${err.response.data.msg} !`, {containerId:'DisplayInfo', theme: "colored" });
            }
            else{
                toast.error(`${err} !`, {containerId:'DisplayInfo', theme: "colored" })
            }
            setLoading(false)
        }
    }

    return (
        <div className="login_container">
            <div className="login_image">
                <img src={bg4} />
            </div>
            <div className="login_page">
                {
                    loading ? <Loader /> : 
                    <> 
                        <h2>Login to Your Account</h2>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <label className="form-label" >Email</label>
                                <input type="email" placeholder="Enter email" id="email" value={email} name="email" className="label-input form-control"
                                    onChange={handleChangeInput}
                                />
                            </div>
                            <div>
                                <label className="form-label" >Password</label>
                                <input type="password" placeholder="Enter password" id="password" value={password} name="password" className="label-input form-control"
                                    onChange={handleChangeInput}
                                />
                            </div>

                            <div className="login-row">
                                <Link to="/register">Don't have an Account?</Link>
                                <button className="btn btn-success"  type="submit">Login</button>
                            </div>
                        </form>

                    </>
                }


            </div>
        </div>
    )
}
